// removed by extract-text-webpack-plugin
module.exports = {"form__control-label":"formularioUsuario__form__control-label___YgZEc","form__footer":"formularioUsuario__form__footer___ktSrR","form__message-error":"formularioUsuario__form__message-error___2WCrY","form__field--error":"formularioUsuario__form__field--error___3chYO"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/admin/MantenedorPersonal/formularioUsuario.css
// module id = 1077
// module chunks = 0